import moment from 'moment'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { stringToDate } from 'modules/core/lib/dates'

import { normalizePayrollRunStatus } from 'modules/compensations/lib/payrollRunStatus'

export type TriggeredByAction =
  | 'lock'
  | 'export'
  | 'sync'
  | 'send_to_bk'
  | 'import_results'
  | 'complete'

type CycleStatusChangedProperties = {
  cycle_id: string
  company_id: string
  previous_status: string
  new_status: string
  triggered_by_action: TriggeredByAction
  cycle_period_start: string
  cycle_period_end: string
  days_since_cycle_creation: number
  country: string
}

export const getDaysSinceCycleStart = (cycleStartDate: string): number => {
  return Math.max(0, moment().diff(stringToDate(cycleStartDate, 'backend_datetime'), 'days'))
}

export const trackCycleStatusChanged = (properties: CycleStatusChangedProperties) => {
  track(trackingEvents.compensations.cycleStatusChanged, {
    ...properties,
    previous_status: normalizePayrollRunStatus(properties.previous_status),
    new_status: normalizePayrollRunStatus(properties.new_status),
  })
}
